import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import { useCallback } from 'react';

interface UseEndCallProps {
  zegoInstance: ZegoUIKitPrebuilt | null;
  setZegoInstance: (instance: ZegoUIKitPrebuilt | null) => void;
  setRedirecting: (redirecting: boolean) => void;
  redirectToDashboard: () => void;
  setError: (error: string) => void;
}

export const useEndCall = ({
  zegoInstance,
  setZegoInstance,
  setRedirecting,
  redirectToDashboard,
  setError,
}: UseEndCallProps) => {
  return useCallback(async () => {
    try {
      if (zegoInstance) {
        console.log('Destroying Zego instance');
        await zegoInstance.destroy();
      }
      setZegoInstance(null);
      setRedirecting(true);
      redirectToDashboard();
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      setError(`Failed to end call: ${errorMessage}`);
    }
  }, [zegoInstance, setZegoInstance, setRedirecting, redirectToDashboard, setError]);
};


export default useEndCall;